import { buildRadarPolygonPoints, buildAxisEndpoints, type RadarInput } from "./radarMath";

export interface RadarChartProps {
  points: RadarInput[]; // exactly 6, in dimension order
  size?: number;
}

const RINGS = [25, 50, 75, 100];

export function RadarChart({ points, size = 280 }: RadarChartProps) {
  const cx = size / 2;
  const cy = size / 2;
  const maxRadius = size / 2 - 40;
  const polygon = buildRadarPolygonPoints(points, cx, cy, maxRadius);
  const axes = buildAxisEndpoints(points.length, cx, cy, maxRadius);
  const numberPoints = buildAxisEndpoints(points.length, cx, cy, maxRadius + 16);

  return (
    <div className="radar-chart">
      <svg
        viewBox={`0 0 ${size} ${size}`}
        width={size}
        height={size}
        role="img"
        aria-label="Radar de dimensiones de seguridad"
      >
        {RINGS.map((ringPct) => (
          <polygon
            key={ringPct}
            points={buildRadarPolygonPoints(
              points.map((p) => ({ ...p, pct: ringPct })),
              cx,
              cy,
              maxRadius
            )}
            fill="none"
            stroke="#334155"
            strokeWidth={1}
          />
        ))}
        {axes.map((endpoint, i) => (
          <line key={i} x1={cx} y1={cy} x2={endpoint.x} y2={endpoint.y} stroke="#334155" strokeWidth={1} />
        ))}
        <polygon points={polygon} fill="rgba(0, 211, 205, 0.25)" stroke="#00D3CD" strokeWidth={2.5} />
        {points.map((p, i) => (
          <text
            key={p.label}
            x={numberPoints[i].x}
            y={numberPoints[i].y}
            fontSize={12}
            fontWeight={700}
            textAnchor="middle"
            dominantBaseline="middle"
            fill="#00DB8F"
          >
            {i + 1}
          </text>
        ))}
      </svg>
      <ol className="radar-legend">
        {points.map((p, i) => (
          <li key={p.label}>
            <span className="radar-legend-number">{i + 1}</span>
            <span className="radar-legend-label">{p.label}</span>
            <span className="radar-legend-pct">{p.pct}%</span>
          </li>
        ))}
      </ol>
    </div>
  );
}
